export const LINKEDIN_WIZARDS = {
  CAMPAIGN_CREATION: 'CAMPAIGN_CREATION',
  CAMPAIGN_SETTINGS: 'CAMPAIGN_SETTINGS',
  AD_GROUP_SETTINGS: 'AD_GROUP_SETTINGS',
  AD_EDITOR: 'AD_EDITOR',
};

export const LINKEDIN_WIZARD_STEP_PATHS = {
  LI_COMPANY_PAGE_LINKING: 'LI_COMPANY_PAGE_LINKING',
  BUILD_ADS: 'BUILD_ADS', // Parent step
  LINKEDIN_AD: 'LINKEDIN_AD',
  MULTI_AD_MANAGER: 'MULTI_AD_MANAGER',
  TARGETING: 'TARGETING',
  BUDGET: 'BUDGET',
  SUMMARY: 'SUMMARY',
};

export const getFlow = ({
  isCompanyPageReady,
  isMultiAdModel,
  isAdStepActive,
}) => {
  const multiAdSteps = isAdStepActive ? [
    LINKEDIN_WIZARD_STEP_PATHS.MULTI_AD_MANAGER,
    LINKEDIN_WIZARD_STEP_PATHS.LINKEDIN_AD,
  ] : [
    LINKEDIN_WIZARD_STEP_PATHS.MULTI_AD_MANAGER,
  ];

  const steps = [
    ...(isCompanyPageReady ? [] : [LINKEDIN_WIZARD_STEP_PATHS.LI_COMPANY_PAGE_LINKING]),

    ...(isMultiAdModel ? multiAdSteps : [LINKEDIN_WIZARD_STEP_PATHS.LINKEDIN_AD]),

    LINKEDIN_WIZARD_STEP_PATHS.TARGETING,
    LINKEDIN_WIZARD_STEP_PATHS.BUDGET,
    LINKEDIN_WIZARD_STEP_PATHS.SUMMARY,
  ];

  return steps;
};
